<template>
  <div class="collage-carousel">
    <div class="collage-grid">
      
      <!-- 🌸 Imagen 1 (Con flornueva.avif arriba derecha y flornueva.avif debajo/lateral izquierdo) -->
      <div
        ref="itemTop"
        class="collage-item item-top"
        @click="enlargeImage(0)"
      >
        <img src="@/assets/flornueva.avif" class="decor-flower flower-top-right" alt="Flor superior derecha">
        <img src="@/assets/flornueva.avif" class="decor-flower flower-under-left" alt="Flor debajo de la imagen 1">
        
        <div class="image-frame">
          <img :src="images[0]" class="collage-image" alt="Imagen 1">
        </div>
      </div>

      <!-- ✨ EFECTO DE RASGADO DE PAPEL REALISTA ENTRE FOTOS -->
      <div class="torn-paper-container" aria-hidden="true">
        <div class="torn-paper-edge"></div>
      </div>

      <!-- 🌸 Imagen 2 (Con elemento2.png abajo y elemento2.png en la parte alta del lado izquierdo) -->
      <div
        ref="itemBottom"
        class="collage-item item-bottom"
        @click="enlargeImage(1)"
      >
        <img src="@/assets/elemento2.png" class="decor-flower flower-middle-left" alt="Flor parte alta izquierda imagen 2">
        
        <div class="image-frame">
          <img :src="images[1]" class="collage-image" alt="Imagen 2">
        </div>
        
        <img src="@/assets/elemento2.png" class="decor-flower flower-bottom-right" alt="Flor inferior derecha">
      </div>

    </div>

    <!-- Modal para ampliar imagen -->
    <div v-if="isImageEnlarged" class="image-modal" @click="closeModal">
      <img :src="images[currentIndex]" class="enlarged-image" alt="Imagen ampliada">
    </div>
  </div>
</template>

<script>
import { ref, onMounted, nextTick } from 'vue'
import gsap from 'gsap'

export default {
  name: 'CollageAnimado',
  setup() {
    const images = [
      require('@/assets/A7402831_11zon.webp'),
      require('@/assets/A7402910_11zon.webp')
    ]

    const currentIndex = ref(0)
    const isImageEnlarged = ref(false)
    
    const itemTop = ref(null)
    const itemBottom = ref(null)

    const enlargeImage = (index) => {
      currentIndex.value = index
      isImageEnlarged.value = true
    }

    const closeModal = () => {
      isImageEnlarged.value = false
    }

    onMounted(async () => {
      await nextTick()

      const elements = [itemTop.value, itemBottom.value].filter(Boolean)
      gsap.set(elements, { opacity: 0, y: 35, scale: 0.97 })

      const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (entry.target === itemTop.value) {
              gsap.to(itemTop.value, {
                opacity: 1,
                y: 0,
                scale: 1,
                duration: 1.2,
                ease: 'power3.out'
              })
            }
            if (entry.target === itemBottom.value) {
              gsap.to(itemBottom.value, {
                opacity: 1,
                y: 0,
                scale: 1,
                duration: 1.2,
                delay: 0.25,
                ease: 'power3.out'
              })
            }
            obs.unobserve(entry.target)
          }
        })
      }, { threshold: 0.2 })

      if (itemTop.value) observer.observe(itemTop.value)
      if (itemBottom.value) observer.observe(itemBottom.value)
    })

    return {
      images,
      currentIndex,
      isImageEnlarged,
      enlargeImage,
      closeModal,
      itemTop,
      itemBottom
    }
  }
}
</script>

<style scoped>
.collage-carousel {
  width: 100%;
  max-width: 520px;
  margin: 0 auto;
  padding: 30px 12px;
  background-color: #ebdce0;
}

.collage-grid {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.collage-item {
  position: relative;
  cursor: pointer;
  will-change: transform, opacity;
}

/* Marco elegante blanco estilo Polaroid */
.image-frame {
  background: #ffffff;
  padding: 10px 10px 16px 10px;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.08);
  border-radius: 4px;
}

.collage-image {
  width: 100%;
  height: auto;
  object-fit: cover;
  display: block;
  transition: transform 0.5s cubic-bezier(0.25, 1, 0.5, 1);
}

.collage-image:hover {
  transform: scale(1.015);
}

/* ✨ EFECTO DE RASGADO DE PAPEL REALISTA ENTRE FOTOS */
.torn-paper-container {
  width: 100%;
  height: 26px;
  position: relative;
  margin: -14px 0;
  z-index: 6;
  overflow: visible;
}

.torn-paper-edge {
  width: 100%;
  height: 100%;
 
}

/* FLORES DECORATIVAS CON OPACIDADES Y POSICIONES EXACTAS */
.decor-flower {
  position: absolute;
  pointer-events: none;
  z-index: 7;
  user-select: none;
  will-change: transform, opacity;
}

/* 1. Flornueva.avif - Esquina superior derecha */
.flower-top-right {
  top: -38px;
  right: -78px;
  width: 140px;
  height: auto;
  opacity: 0.88;
  transform: rotate(-45deg);
}

/* 2. Flornueva.avif - Debajo/lateral izquierdo de la primera imagen */
.flower-under-left {
  bottom: -25px;
  left: -75px;
  width: 130px;
  height: auto;
  opacity: 0.8;
  transform: rotate(35deg);
  z-index: 5; /* Queda sutilmente por debajo del marco */
}

/* 3. Elemento2.png - Lado izquierdo en la parte alta de la segunda imagen */
.flower-middle-left {
  top: 25px;
  left: -35px;
  width: 125px;
  height: auto;
  opacity: 0.78;
  z-index:-1 !important;
  transform: rotate(-35deg);
}

/* 4. Elemento2.png - Esquina inferior derecha */
.flower-bottom-right {
  bottom: -22px;
  right: -45px;
  width: 135px;
  height: auto;
  opacity: 0.72;
  transform: rotate(25deg);
}

/* Modal de imagen ampliada */
.image-modal {
  position: fixed;
  inset: 0;
  background-color: rgba(15, 15, 15, 0.92);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
  backdrop-filter: blur(4px);
}

.enlarged-image {
  max-width: 90%;
  max-height: 90%;
  border-radius: 8px;
  object-fit: contain;
  box-shadow: 0 20px 40px rgba(0,0,0,0.4);
}
</style>